module.exports = __webpack_public_path__ + "static/media/undraw_news_go0e.c96e5a3e.svg";